import classNames from "classnames";

export default function PostTitle({ children }) {
  return (
    <h1
      className={classNames(
        "text-3xl md:text-4xl lg:text-4.5xl font-bold tracking-tight",
        "leading-tight lg:leading-tight mb-12 text-dark-purple"
      )}
    >
      {children}
    </h1>
  );
}
